export default __webpack_public_path__ + "static/media/expand.b78851b8.svg";